(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

(() => {
  document.addEventListener('keydown', (event) => {
    const nav = document.querySelector('#site-control .multi-level-nav');
    if (!nav || !(event.target instanceof Element)) return;
    const launcher = nav.querySelector('.tier-1 a[aria-expanded="true"]');
    if (event.key === 'Escape' && launcher) {
      event.preventDefault();
      window.theme?.closeOpenMenuItem?.();
      launcher.focus();
    } else if (event.key === 'Tab' && !event.shiftKey && event.target === launcher) {
      const firstLink = nav.querySelector('.tier-2 a');
      if (firstLink) {
        event.preventDefault();
        firstLink.focus();
      }
    } else if (event.key === ' ' && event.target.matches('.tier-1 .contains-mega-menu > a')) {
      event.preventDefault();
      event.target.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true }));
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucent-frame-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucent-frame-finder')) {
    customElements.define('lucent-frame-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.querySelector('form').addEventListener('submit', event => {
          event.preventDefault();
          const preferences = new FormData(event.currentTarget);
          const size = preferences.get('size');
          const shape = preferences.get('shape');
          const color = preferences.get('color');
          const style = preferences.get('style');
          const cards = [...this.querySelectorAll('.lucent-finder-card')];
          cards.forEach(card => { card.hidden = true; });
          const matches = cards.filter(card => !size || card.dataset.sizes.includes('|' + size + '|')).map((card, index) => {
            const text = card.dataset.search;
            let score = 0;
            if (shape && text.includes(shape)) score += 4;
            if (color && (card.dataset.colors + text).includes(color)) score += 3;
            const bold = /bold|thick|oversized|geometric|statement/.test(text);
            const subtle = /metal|titanium|wire|slim|thin|rimless/.test(text);
            if ((style === 'bold' && bold) || (style === 'understated' && subtle)) score += 2;
            return {card, score, index};
          }).sort((a,b) => b.score - a.score || a.index - b.index).slice(0,6);
          matches.forEach(({card}, index) => { card.hidden = false; card.style.order = index; });
          const results = this.querySelector('.lucent-finder-results');
          results.hidden = false;
          this.querySelector('[data-result-status]').textContent = matches.length ? this.dataset.resultCopy : this.dataset.emptyCopy;
          results.querySelector('h2').focus();
        }, {signal: this.abort.signal});
      }
      disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
